import React from 'react';
import Button from "../button/Button";
import buttonStyles from "../button/Button.module.scss";
import {safeHTML} from "../../../../utils/safeHTML";
import Picture from "../picture/Picture";
import styles from "./Footer.module.scss";
import classNames from "classnames";

export default function FooterApp({title, text, image, button}) {
  return (
    <div className={styles.footer__app}>
      <div className={styles.footer__appImage}>
        <Picture {...image}/>
      </div>
      <div className={styles.footer__appTitle}>{safeHTML(title)}</div>
      <div className={styles.footer__appText}>{safeHTML(text)}</div>
      <Button className={classNames(
        styles.footer__appButton,
        buttonStyles.button_black,
        buttonStyles.button_appButton,
      )}
              {...button?.attr}
              icon={button.icon}
              text={button.text}>
        <div className={buttonStyles.button__effect}/>
      </Button>
    </div>
  )
}
